/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const SyncProductPage = lazyLoad(
  () => import('./index'),
  module => module.SyncProductPage
);
